import React from 'react';
import PrivateRoute from '../components/PrivateRoute';
import { GLOBAL_COMMUNICATION_ROLES } from '../modules/notifications/communicationsAccessPolicy';
import CommunicationsLog from './CommunicationsLog';

const CommunicationsLogRoute: React.FC = () => (
  <PrivateRoute roles={GLOBAL_COMMUNICATION_ROLES}>
    <CommunicationsLog />
  </PrivateRoute>
);

export default CommunicationsLogRoute;
